import {isObject} from 'lodash';
import {FC} from 'react';
import {Icon, Label, Popup} from 'semantic-ui-react';

import {PredefinedDashboard} from '../types';

import './PredefinedDashboardIcons.less';

type DashboardIconsProps = {
  asLabel?: boolean;
  isDashboardInstance?: boolean;
  predefinedDashboard?: PredefinedDashboard;
}
export const PredefinedDashboardIcons: FC<DashboardIconsProps> = ({
  asLabel,
  isDashboardInstance,
  predefinedDashboard
}) => {
  if (!predefinedDashboard) {
    return null;
  }
  const labelProperty = predefinedDashboard.schema.properties?.label;
  const label = (isObject(labelProperty) && labelProperty.default);
  const autoscalingIcon = <i className='icon apstra-icon apstra-icon-dashboard-autoscaling' />;
  const dynamicIcon = <i className='icon apstra-icon apstra-icon-dashboard-dynamic' />;
  return (
    <span className='predefined-dashboard-icons'>
      <Popup
        content='Predefined dashboard'
        header={label}
        position='right center'
        size='tiny'
        trigger={asLabel ? <Label icon='box' /> : <Icon name='box' />}
      />
      {predefinedDashboard.autoscaling &&
        <Popup
          content={isDashboardInstance ?
            'This dashboard is an instance of an autoscaling dashboard' :
            'This dashboard automatically creates and removes its instances'
          }
          header='Autoscaling'
          position='right center'
          size='tiny'
          trigger={asLabel ? <Label icon={autoscalingIcon} /> : autoscalingIcon}
        />
      }
      {predefinedDashboard.dynamic &&
        <Popup
          content='This dashboard has dynamic widgets'
          header='Dynamic'
          position='right center'
          size='tiny'
          trigger={asLabel ? <Label icon={dynamicIcon} /> : dynamicIcon}
        />
      }
    </span>
  );
};
